// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5eda5953","732":"27d49415","977":"8b8dc947"}[chunkId] + ".chunk.js";
};